/** WI 34966: a Viewpoint GL account (bGLAC) offered by the NCR form's GL account typeahead. */
export interface VpGlAccount {
  /** The account number, e.g. "6000-00-000". The saved answer. */
  glAcct: string;
  description: string;
  /** The GL company the account belongs to. */
  companyID: number;
  /** "number description", the label both platforms render. */
  name: string;
}
